<template>
	<el-footer>
		<div class="foot-content">
			<div class="whatsup-card">
				<img src="../assets/imgs/whatsup-card.jpg" />
			</div>
			<el-col class="foot-statement cr-grey9">
				<div>
					<router-link to="/">{{ $t("menuList.home") }}</router-link>
					<router-link to="/aboutUs">
						{{ $t("menuList.aboutUs") }}
					</router-link>
					<router-link to="/product">{{
						$t("menuList.products")
					}}</router-link>
					<router-link to="/Internet">FBox</router-link>
					<router-link to="/Internet/HMI">HMI</router-link>
					<router-link to="/Internet/PLC">PLC</router-link>
					<router-link to="/productTechnology">{{
						$t("menuList.Technology")
					}}</router-link>
					<router-link to="/contact">{{
						$t("menuList.contactUs")
					}}</router-link>
				</div>
			</el-col>
			<el-col class="foot-bottom">
				<!-- <p>
          <a>关于本站</a><a>产品展示</a><a>关于公司</a><a>用户规则</a
          ><a>联系我们</a><a>投诉建议</a>
        </p> -->
				<p>
					{{ $t("copyright") }}
					<!-- Copyright © 2020-2030 深圳安赛龙科技有限公司版权所有
          经营许可证：粤******** 营业执照 ************ -->
				</p>
			</el-col>
			<div class="card">
				<img src="../assets/imgs/card.jpg" />
			</div>
			<div v-show="show" @click="comeBack" class="back">
				<img src="../assets/imgs/back.png" />
			</div>
		</div>
	</el-footer>
</template>
<script>
export default {
	data() {
		return {
			setGoBackE: "",
			show: false,
			timer: null,
		};
	},
	mounted() {
		window.addEventListener("scroll", this.setGoBack, true);
	},
	destroyed() {
		window.removeEventListener("scroll", this.setGoBack);
	},
	methods: {
		setGoBack() {
			const that = this;
			let scrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop;
			that.scrollTop = scrollTop;
			that.show = scrollTop > 300 ? true : false;
		},
		comeBack() {
			const that = this;
			let timer = setInterval(() => {
				let ispeed = Math.floor(-that.scrollTop / 5);
				document.documentElement.scrollTop = document.body.scrollTop =
					that.scrollTop + ispeed;
				if (that.scrollTop === 0) {
					clearInterval(timer);
				}
			}, 16);
		},
	},
};
</script>
<style lang="scss">
.el-footer {
	background: #181818;
	color: #dddddd;
	height: 160px !important;
}
.foot-content {
	width: 1200px;
	margin: 0 auto;
	position: relative;
	.whatsup-card {
		position: absolute;
		top: 10px;
		img {
			width: 140px;
		}
	}
	.card {
		position: absolute;
		right: 0;
		top: 10px;
		img {
			width: 140px;
		}
	}
	.back {
		position: fixed;
		bottom: 180px;
		right: 10px;
	}
	.footer-nav {
		height: 174px;
	}
	.footer-catalog {
		width: 298px;
		float: left;
		li {
			margin-bottom: 10px;
			cursor: pointer;

			> span {
				display: inline-block;
				width: 120px;
				color: #666;
				&:hover {
					color: #444;
				}
			}
		}
		li:first-child {
			font-size: 18px;
			color: #333;
			margin: 30px 0 20px 0;
		}
	}
	.footer-icon {
		width: 403px;
		float: left;
	}
	.foot-statement {
		height: 60px;
		border: 1px solid #131313;
		// margin-bottom: 18px;
		margin-top: 36px;
		font-size: 12px;
		line-height: 20px;
		display: flex;
		div {
			margin: 0 auto;
		}
		a {
			color: #fff;
			font-size: 14px;
			padding: 8px 20px;
		}
	}
	.foot-bottom {
		height: 80px;
		text-align: center;
		p {
			display: inline-block;
			margin: 10px 0 15px 0;
			a {
				color: #444;
				padding: 0 5px;
				border-right: 1px solid 666;
				&:last-child {
					border: none;
				}
			}
		}
		p:last-child {
			font-size: 14px;
			color: 666;
			margin: 0;
		}
	}
}
</style>
